import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconPropertyApartmentSvg } from "./IconPropertyApartmentSvg.mjs";
const IconPropertyApartment = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconPropertyApartmentSvg, ...iconProps });
};
export {
  IconPropertyApartment
};
